import $ from 'jquery';

$(window).load(function() {
	var immagine_visual = document.getElementsByClassName('parallax-img-visual');
	if( immagine_visual.length > 0 ) {
		var scale_value = immagine_visual[0].getAttribute("data-scale");
		if( !scale_value ) { scale_value = 1.3; }
		new simpleParallax(immagine_visual, {
			orientation: 'up',
			scale: scale_value,
			overflow: false
		});
	}

	var immagine_visual_mobile = document.getElementsByClassName('parallax-img-visual-mobile');
	if( immagine_visual_mobile.length > 0 ) {
		var scale_value_mobile = immagine_visual_mobile[0].getAttribute("data-scale");
		if( !scale_value_mobile ) { scale_value_mobile = 1.3; }
		new simpleParallax(immagine_visual_mobile, {
			orientation: 'up',
			scale: scale_value_mobile,
			overflow: false
		});
	}

	if( $(window).width() < 767.5 ) {
		check_img_exceedings_header();
	}
});

$(window).on("resize",function() {
	check_img_exceedings_header();
});

function check_img_exceedings_header() {
	var item = null;
	if( $(window).width() < 767.5 ) {
		item = $('.parallasse_mobile');
	} else {
		item = $('.parallasse');
	}

	var proporzione_img = item.width() / item.height();
	var proporzione_contenitore = $('#slider-header').width() / $('#slider-header').height();
	if(proporzione_img >= proporzione_contenitore) {
		item.removeClass('width');
		item.addClass('height');
	} else {
		item.removeClass('height');
		item.addClass('width');
	}
}


// WEBPACK FOOTER //
// ../views/blocks/slider-header/slider-header.js